import * as Yup from 'yup';

export default function getBooleanSchema(customMessage: string, defaultValue: boolean = false) {
  return Yup.boolean().required(`${customMessage} is required.`).default(defaultValue);
}
